<section class="content profile-page">
  <div class="block-header">
      <div class="">
          <div class="row ">
              <div class=" col-md-12 px-6 col-sm-12 p-0">
                  <h2 class="poppins font-weight-bold">Pay Out Dashboard
                   </h2>
              </div> 
          </div>
      </div>
     
  </div>    
  <div class="  ">
      <div class="row" style="padding-top: 65px;">
          <div class="col-md-12">
              <div> 
                  <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                      <div class="row mx-0">
                          <div class="col-md-3">
                              <div class="">
                                  <div class=" " *ngIf="MerchantLogo">
                                      <img   src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center"id="merchatImage" class="profile fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                  </div>
                                  <div class=" "   *ngIf="PaygLogo">
                                      <img   src="assets/img/user/10.jpg"   class="profile fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                  </div>
                                  <a class="d-block py-2" [routerLink]="'/settings/merchantsettings'"> Change Logo</a>
                                  <!-- <div class=" ">
                                      <img   src="assets/img/user/10.jpg"   class="profile fade-in-on-icon-sidenav img-thumbnail img-rounded">
                                  </div> -->
                              </div>
                          </div>
                          <div class="col-md-9 p-0">
                             
                              <h3 class="m-0 poppins font-weight-bold">   {{businessName}} </h3>
                              <div class="row pt-2">
                                  <div class="col-md-6">
                                      <p > <span class="text-muted">BusinessName:  {{businessName}} </span></p>
                                      <p > <span class="text-muted">MerchantKeyId:   {{merchantKeyId}} </span></p>
                                        <p ><span class="text-muted">UserName:   {{username}}</span> </p>  
                                </div>
                                <div class="col-md-6">
                             
                            
                                  <p>
                                      <img src="assets/img/email-icon.png" alt="" > &nbsp;<span class="text-muted">Email:  care@fastswiff.com</span>
                                      </p>
                                  <p class="robot">
                                      <img src="assets/img/phone-icon.png" alt="" > &nbsp;<span class="text-muted">Phone: +917337327109</span>
                                      </p>
                              </div>
                              </div>
                          </div>
                      </div> 
                  </div>
                
                 
                  </div>
              </div>
      </div> 
   
 
  
  
  </div>
</section>
